// De weergave waarmee een werkgever of admin binnenkomt: werkgever of
// medewerker (`user.updating_role`, de schakelaar "Werkgever" in de sidebar).
//
// De keuze wordt bewaard als user_meta `updating_role` en komt mee in
// `/v1/users/me/info`. Hij werd in de mount van de sidebar in de store gezet:
// landde de gebruiker pas daarna, dan bleef de schakelaar uit terwijl het
// werkgeversdashboard wel toonde, en elke nieuwe sidebar (elke layout mount er
// een) zette hem terug op de `meta` van de laatste read -- ook als de gebruiker
// hem sindsdien had omgezet. Nu wordt hij één keer gezet, zodra de gebruiker
// landt; daarna is de store de bron.
//
// Bewust zonder imports: de standalone testscripts laden dit bestand direct.

// De weergave om te zetten, of null als er niets te zetten valt: de gebruiker
// is er nog niet, heeft al een weergave, of kan niet wisselen. Een medewerker
// krijgt nooit een bewaarde werkgeversweergave, ook niet uit een meta van
// toen hij nog werkgever was.
export function initialViewRole(user) {
  if (!user || user.id == null || user.id === -1 || user.updating_role) return null;
  if (user.role !== "employer" && user.role !== "admin") return null;

  const saved = Array.isArray(user.meta)
    ? user.meta.find((entry) => entry && entry.type === "updating_role")
    : null;
  if (saved && (saved.value === "employer" || saved.value === "user")) return saved.value;

  return user.role === "employer" ? "employer" : "user";
}

// Zet de weergave zodra de gebruiker landt, welk scherm hem ook ophaalt. Een
// $patch roept subscriptions synchroon aan na het mergen, dus dit staat er
// vóór de watchers van de schermen die erop lezen.
export function seedViewRoleOnLanding(store) {
  store.$subscribe(() => {
    const role = initialViewRole(store.user);
    if (role) store.$patch({ user: { updating_role: role } });
  });
}
